import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { ActionButton, ArchiveButton, DeleteButton } from "@hydrologiq/shared/content/components/Button"
import { Text, Dialog as ChakraDialog } from "@chakra-ui/react"
import { useState } from "react"
import { useMutation } from "@apollo/client"
import { ArchiveCustomerSiteDocument } from "@hydrologiq/gql/graphql"
import { useCopyValues } from "@hydrologiq/shared/providers/helpers/useCopy"
import { COPY_KEYS, DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"

const CustomerSiteArchive = ({
  customer,
  site,
  onSiteRemoved,
}: {
  customer: string
  site: string
  onSiteRemoved: (id: string) => void
}) => {
  const [archiveCustomerSite, { loading }] = useMutation(ArchiveCustomerSiteDocument)

  const [open, setOpen] = useState(false)

  const copy = useCopyValues({
    [COPY_KEYS.BUTTONS.ARCHIVE]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.ARCHIVE],
    [COPY_KEYS.BUTTONS.CANCEL]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.CANCEL],
    [COPY_KEYS.LABELS.SITE]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.SITE],
    [COPY_KEYS.HEADINGS.CUSTOMER]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.CUSTOMER],
  })

  const onArchive = () => {
    if (site) {
      archiveCustomerSite({ variables: { customerId: customer, siteId: site } }).then(() => {
        onSiteRemoved(site)
        setOpen(false)
      })
    }
  }

  return (
    <Dialog
      title={`${copy[COPY_KEYS.BUTTONS.ARCHIVE]} ${copy[COPY_KEYS.LABELS.SITE].toLowerCase()}`}
      trigger={
        <ArchiveButton
          context={{
            label: copy[COPY_KEYS.BUTTONS.ARCHIVE],
            description: `${copy[COPY_KEYS.BUTTONS.ARCHIVE]} the current ${copy[COPY_KEYS.LABELS.SITE].toLowerCase()}`,
            variant: "warning",
          }}
        />
      }
      footer={
        <>
          <ChakraDialog.ActionTrigger asChild>
            <ActionButton
              disabled={loading}
              context={{
                label: copy[COPY_KEYS.BUTTONS.ARCHIVE],
                description: `${copy[COPY_KEYS.BUTTONS.ARCHIVE]} the current ${copy[
                  COPY_KEYS.LABELS.SITE
                ].toLowerCase()}`,
                variant: "secondary",
              }}
              onClick={onArchive}
            />
          </ChakraDialog.ActionTrigger>
          <ActionButton
            disabled={loading}
            onClick={() => setOpen(false)}
            context={{
              label: copy[COPY_KEYS.BUTTONS.CANCEL],
              description: `Do not ${copy[COPY_KEYS.BUTTONS.ARCHIVE].toLowerCase()} the current ${copy[
                COPY_KEYS.LABELS.SITE
              ].toLowerCase()}`,
              variant: "primary",
            }}
          />
        </>
      }
      loading={loading}
      disabled={loading}
      open={open}
      setOpen={setOpen}
    >
      <Text>
        Are you sure you want to {copy[COPY_KEYS.BUTTONS.ARCHIVE].toLowerCase()} this{" "}
        {copy[COPY_KEYS.LABELS.SITE].toLowerCase()}?
      </Text>
    </Dialog>
  )
}

export default CustomerSiteArchive
